import script from "./cginsurepoint.vue?vue&type=script&setup=true&lang=js"
export * from "./cginsurepoint.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__